<template>
    <div>
      <div style="display: flex">
        <Multiselect
            ref="folderSelection"
            v-model="searchKey" 
            :options="allOptionsList"
            :multiple="enableMultiSelect"
            track-by="path"
            :custom-label="selectionLabelCallback"
            :close-on-select="true"
            :show-no-results="false"
            deselectLabel =""
            selectLabel=""
            selectedLabel=""
            :placeholder="$t('Filter by name')"
            :hideSelected="false"
            :showNoOptions="false"
            @search-change="displayOptionsOnSearch($event)"
            @select="selectFolders($event)"
            @remove="removeDirectories($event)"
            class="permission-field"
            :style="setDefaultFocus?'box-shadow: rgb(14, 61, 112) 0px 0px 2px 3px !important;height: 40px;border-radius: 4px;':''">
            <span slot="noResult">No results</span>
            <span slot="noOptions" style="display:none"></span>
            <div v-if="enableMultiSelect" slot="tag" slot-scope="option" class="selected-tags-style" style="text-align:start" :style="from && from == 'Advanced Search'?'min-height:25px !important;padding-top:2px !important':''">
              <div class="tags-display-style" :title="getCheckedFolderDisplayPath(option.option)">{{option.option.path}}</div>
                  <div v-if="enableMultiSelect" v-on:click="removeSelectedDirOption(option.option)" lass="remove-tag">
                      <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                      </svg>
                  </div>
            </div>
            <div style="display:flex;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <input v-if="enableMultiSelect" type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeFoldersCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.dir_name"/>
            <div class='d-block'>
              <div style="margin-inline-start:12px;">{{ scope.option.dir_name }}</div>
              <div class="label-tree-style">
                {{getCheckedFolderDisplayPath(scope.option)}}
              </div>
            </div>
            </div>
        </Multiselect>
        <browse-icon v-if="enableFolderBrowser" :wrapcontentwithbutton="true" title="Browse Folder"
                    @click.native="isFolderBrowse=true"
                    class="save-cancel-icon browse-icon"
                    style="width:40px;height:30px;">
        </browse-icon>
      </div>
      <select-folder
        ref="catalogsBrowseModal"
        v-if="isFolderBrowse"
        :workspaceList="folderWorkspaceList"
        :enableAssetMultiSelect="enableMultiSelect"
        @close="isFolderBrowse = false"
        @handleFilesBrowse="refreshBrowsedFolder"
        :enableRecursive="false"
        :browseOnlyFolders="true"
        style="z-index:99"
      ></select-folder>
    </div>
  </template>
  
  <script>
  import fileBrowseModel from "../files/filesBrowse.vue";
  import Constants from "../../components.constants.js"
  import Multiselect from 'vue-multiselect';
  import {mapActions} from "vuex";
  import BrowseIcon from "../core/InlineBrowseField.vue";
  
  export default {
          props:["componentUUID", "enableFolderBrowser", "enableMultiSelect", "setDefaultFocus", "selectedFolders", "from", "binTypesFilter"],
          data() {
              return {
                  dropdownOpenDirection:"below",
                  rootBinsList:[],
                  folderIdList:[],
                  searchKey: [],
                  allOptionsList: [],
                  isFolderBrowse:false,
                  folderWorkspaceList:[Constants.WORKSPACE_BINS],
              }
          },
          components:{
              "Multiselect":Multiselect,
              "select-folder":fileBrowseModel,
              "browse-icon":BrowseIcon,
          },
          methods:{
                removeSelectedDirOption(option){
                  this.searchKey = this.searchKey.filter(e => e.path != option.path);
                  this.$emit("removedCatalogFromList",option)
                },
                removeDirectories(option){
                  let index = this.allOptionsList.findIndex(item => item.path == option.path);
                  if(index > -1){
                      this.allOptionsList[index].checked = false;
                      this.$emit("removedCatalogFromList",option)
                  }
                },
                selectionLabelCallback(option){
                    if(option.dir_name != undefined){
                      return `${option.dir_name}`
                    }
                },
                fetchBinsFromServer(){
                    this.rootBinsList = []
                    this.allOptionsList = []
                    let payload = {params:{bin_type:"asset",status:"active"}}
                    //Only check: is it an array? Does it have values?
                    if(this.binTypesFilter && Array.isArray(this.binTypesFilter) && this.binTypesFilter.length > 0){
                      payload["params"]["bin_type"] = JSON.stringify(this.binTypesFilter)
                    }
                    this.getAllBinsFromServer(payload).then(data=>{
                        if ("bins" in data) {
                            for(let bin of data["bins"]){
                                let temp = bin
                                temp["_id"] = bin.bin_id
                                temp["id"] = bin.bin_id
                                temp["parent_id_path"]="share_id:/"
                                temp["path"] = `share://${bin.bin_id}`
                                temp["dir_name"] = bin.bin_name
                                this.rootBinsList.push(temp)
                                this.allOptionsList.push(temp)
                            }
                        }
                    })
                },
                displayOptionsOnSearch(filterBy){
                    let payload = {params:{limit:10}}
                    if(filterBy){
                      payload.params["keyword"] = filterBy
                    }
                    this.allOptionsList = []
                    this.getAutoCompletedFoldersFromServer(payload).then(data=>{
                      this.allOptionsList = this.rootBinsList.filter(op=>op.dir_name.toLowerCase().startsWith(filterBy.toLowerCase()))
                      if('files' in data){
                        this.allOptionsList = this.allOptionsList.concat(data["files"])
                      }
                      if(this.allOptionsList.length > 10){
                        this.allOptionsList = this.allOptionsList.slice(0, 10);
                      }
                  })
                },
                selectFolders(option){
                    let index = this.allOptionsList.findIndex(item => item._id == option._id);
                    if(index > -1){
                        this.allOptionsList[index].checked = true;
                        if(typeof this.componentUUID != "undefined"){
                            this.$emit("folderSelectionChanged",option,this.componentUUID);
                            return;
                        }
                        this.$emit("folderSelectionChanged",option);
                    }
                },
                refreshBrowsedFolder(folderInfoList){
                  if(folderInfoList && folderInfoList.length > 0){
                    for(let option of folderInfoList){
                      if(this.enableMultiSelect){
                        let index = this.searchKey.findIndex(item => item.path == option.path);
                        if(index <= -1){
                          this.searchKey.push(option);
                          if(typeof this.componentUUID != "undefined"){
                            this.$emit("folderSelectionChanged",option,this.componentUUID);
                            this.isFolderBrowse = false;
                            return;
                          }
                          this.$emit("folderSelectionChanged",option);
                        }
                      }else{
                      this.searchKey = option;
                          if(typeof this.componentUUID != "undefined"){
                            this.$emit("folderSelectionChanged",option,this.componentUUID);
                            this.isFolderBrowse = false;
                            return;
                          }
                          this.$emit("folderSelectionChanged",option);
                      }
                    }
                    this.isCategoryBrowse = false;
                  }else{
                    console.log("Failed to update the browsed folder path:",folderInfoList)
                  }
                    // if(folderInfoList && folderInfoList.length > 0){
                    //     if(typeof this.componentUUID != "undefined"){
                    //         this.$emit("folderSelectionChanged",folderInfoList,this.componentUUID);
                    //         this.isFolderBrowse = false;
                    //     }
                    //     this.$emit("folderSelectionChanged",folderInfoList);
                    //     if(this.enableMultiSelect){
                    //       this.searchKey.push(folderInfoList);
                    //     }else{
                    //       this.searchKey = folderInfoList[0];
                    //     }
                    // }else{
                    //     console.log("Failed to update the browsed folder path:",folderInfoList)
                    // }
                    this.isFolderBrowse = false
                },
                getCheckedFolderDisplayPath(option){
                    if(option == undefined){
                      return "None";
                    }
                    if("parent_path" in option){
                      if(Array.isArray(option.parent_path)){
                        return option.parent_path[0]
                      }else{
                        return option.parent_path
                      }
                    }else{
                      return option.path;
                    }
                },
                makeFoldersCheckBoxSelection(option){
                  if(this.searchKey != undefined){
                    return this.searchKey.some((op) => op.path === option.path);
                  }
                  return false;
                },
                getSelectedFolderPaths(){
                  if(Array.isArray(this.searchKey)){
                    let temp = []
                    for(let op of this.searchKey){
                      if(!temp.includes(op.path)){
                        temp.push(op.path)
                      }
                    }
                    return temp
                  }
                  if(this.searchKey){
                    return this.searchKey.path
                  }else{
                    return ""
                  }
                },
                ...mapActions("bins",["getAllBinsFromServer"]),
                ...mapActions("files",["getAutoCompletedFoldersFromServer"],)
          },
          created(){
            if(this.selectedFolders){
              if(this.enableMultiSelect){
                if(Array.isArray(this.selectedFolders)){
                  this.searchKey = this.selectedFolders;
                }else{
                  this.searchKey = [this.selectedFolders];
                }
              }else{
                if(Array.isArray(this.selectedFolders)){
                  this.searchKey = this.selectedFolders[0];
                }else{
                  this.searchKey = this.selectedFolders;
                }
              }
            }
            this.fetchBinsFromServer();
          }
  }
  </script>
  
  
  <style scoped lang="scss">
  $table-row-border: none;
  $active-blue: #007bff;
  $danger-color: #dc3545;
  $none-text-color:#4f4f4f;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $active-green-color:#28a745;
  $primary-background: #1a1e21;
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $learn-about-text-color-hover:#b7b327;
  $learn-about-text-color:#9a9620;
  $tags-background-color:#282d31;
  $svg-color:#666;
  $tags-border-color:#363636;
  $secondary-border-color: 1px solid #2b2b2b;
  $icon-hover:#2c3339;
  
  .all-users-selection:hover{
    background: $bg-color-on-hover;
  }
  .selected-tags-style{
    background: $tags-background-color;
    border: 1px solid $tags-border-color;
    border-radius: 15px;
    font-size: 12px !important;
    min-height: 30px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px !important;
    text-align: center;
    width: auto !important;
    padding-inline-start: 12px !important;
    justify-content: center;
    padding-top: 4px !important;
    padding-inline-end: 4px !important;
    .remove-tag{
      line-height:18px;
    }
  }
  
  .bigger-checkboxes {
      height: 30px;
      width: 20px;
      position:relative;
  }
  input[type="checkbox"]:after {
      line-height: 1.5em;
      content: "";
      display: inline-block !important;
      width: 22px !important;
      height: 21px !important;
      margin-top: 5px !important;
      margin-inline-start: -1px !important;
      border: $border-color !important;
      border-radius: 0.25em !important;
      background: $primary-background !important;
  }
  input[type="checkbox"]:checked:after {
      content: "✔";
      color: $active-blue !important;
      position: absolute !important;
      font-size: 16px !important;
      line-height: 1 !important;
      transition: all 0.2s !important;
      font-family: Helvetica, Arial, sans-serif;
      padding-inline-start: 4px !important;
      padding-top: 2px !important;
  }
  
  .user-name-or-image{
      height: 30px;
      width: 30px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: 28px;
      text-transform: uppercase;
      margin-top: 3px;
      margin-inline-end: 5px;
  }
  
  
  .label-tree-style{
    font-size: 12px !important;
    color:$dull-text-color;
    margin-top:4px;
    word-break: break-all;
    white-space: pre-wrap;
    margin-inline-start:8px;
    line-height: 1.2;
  }
  
  ::v-deep{
  .multiselect{
        width:87% !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:70%;
      margin: 0;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: $border-color !important;
            display: block;
            background: $secondary-background-color;
            width: 100%;
            max-height: 245px !important;
            overflow: auto;
            border: $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
            position: absolute;
        }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color!important;
    }
    .multiselect__tags {
        background: transparent !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
}
  .browse-icon{
      position: relative;
      inset-inline-start:8px;
      top: 3px;
  }
  
  .table td, .table th {
      border-top: none;
      padding:0px;
  }
  
  .display-as-tags{
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: start;
      float: inline-start;
  }
  
  .select-catalog-field{
      width: 101%;
      .value-style{
        width:100%;
      }
  }
  
  .user-name-or-image {
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-start: 5px;
  }
  
  .user-name-or-image-in-selected-option{
    border: $border-color;
  height: 26px;
  width: 26px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }
  
  .tags-style{
      display: inline-flex;
      margin-inline-end: 5px;
      margin-bottom: 2px;
      height: 27px;
      margin-inline-start: 3px;
    .user-name-display-as-tags{
        line-height: 27px;
        margin-inline-start: 6px;
    }
  }
  
  .remove-tag{
    color:$dull-text-color;
    line-height: 25px;
  }
  
  .remove-tag:hover{
    color:$text-color;
  }
  
  .save-cancel-icon{
    position:relative;
    top:10px;
    inset-inline-start:5px;
    color:$text-color;
  }
  .browse-icon{
    color:$svg-color !important;
  }
  .browse-icon{
      position: relative;
      inset-inline-start:8px;
      top: 9px;
  }
  
  .browse-icon:hover{
    color:#eee !important;
  }
  
  .tags-display-style{
   word-break: break-all;
  }
  </style>